// extracted by mini-css-extract-plugin
export var copyableField = "_nx-4";
export var customerBadge = "_nx-0";
export var customerInfoTitle = "_nx-2";
export var details = "_nx-1";
export var dropdownContainer = "_nx-5";
export var dropdownImage = "_nx-6";
export var editAssigneeForm = "_nx-a";
export var editButton = "_nx-3";
export var email = "_nx-7";
export var hidden = "_nx-d";
export var input = "_nx-8";
export var saveButton = "_nx-b";
export var shopifyIcon = "_nx-c";
export var suggestionBadge = "_nx-e";
export var suggestionText = "_nx-f";
export var username = "_nx-9";